import { useState, useEffect } from "react";

export default function CookiesCard() {
  const [open, setOpen] = useState(true);

  const defaultState = {
    necessary: true,
    performance: false,
    targeting: false,
    functionality: false,
    unclassified: false,
  };

  const [checkboxes, setCheckboxes] = useState(defaultState);

  useEffect(() => {
    const timer = setTimeout(() => setOpen(false), 10000);
    return () => clearTimeout(timer);
  }, []);

  const handleToggle = (key) => {
    if (key === "necessary") return;
    setCheckboxes((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const handleClose = () => setOpen(false);

  const handleSubmit = (type) => {
    console.log(type === "accept" ? "Accepted:" : "Declined:", checkboxes);
    handleClose();
  };

  const checkboxOptions = [
    { key: "necessary", label: "STRICTLY NECESSARY", locked: true },
    { key: "performance", label: "PERFORMANCE" },
    { key: "targeting", label: "TARGETING" },
    { key: "functionality", label: "FUNCTIONALITY" },
    { key: "unclassified", label: "UNCLASSIFIED" },
  ];

  if (!open) return null;

  return (
    <div className="w-[300px] h-[400px] bg-black rounded-[20px] flex items-center justify-center fixed bottom-[120px] right-6 z-50 ">
      <div className="text-white p-4 w-full h-full flex flex-col justify-between">
        {/* Header */}
        <div>
          <div className="flex justify-between items-start">
            <h2 className="text-lg font-bold leading-tight">This website uses cookies</h2>
            <button className="text-white text-lg font-bold" onClick={handleClose}>
              &times;
            </button>
          </div>
          <p className="text-sm mt-2 text-gray-300">
            This website uses cookies to improve user experience. By using our
            website you consent to all cookies in accordance with our Cookie Policy.
            <span className="underline cursor-pointer"> Read more</span>
          </p>

          {/* Checkboxes */}
          <div className="mt-4 flex flex-col gap-2 text-sm font-semibold">
            {checkboxOptions.map(({ key, label, locked }) => (
              <label key={key} className="flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={checkboxes[key]}
                  onChange={() => handleToggle(key)}
                  readOnly={locked}
                  className="form-checkbox text-black bg-white rounded"
                />
                {label}
              </label>
            ))}
          </div>
        </div>

        {/* Footer Buttons */}
        <div className="flex flex-col gap-3 mt-4">
          <div className="flex gap-2">
            <button
              className="bg-white text-black font-semibold rounded-full w-1/2 py-2 text-sm"
              onClick={() => handleSubmit("accept")}
            >
              ACCEPT ALL
            </button>
            <button
              className="bg-white text-black font-semibold rounded-full w-1/2 py-2 text-sm"
              onClick={() => handleSubmit("decline")}
            >
              DECLINE ALL
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
